import { render, staticRenderFns } from "./chapter_add.vue?vue&type=template&id=05077af6"
import script from "./chapter_add.vue?vue&type=script&lang=js"
export * from "./chapter_add.vue?vue&type=script&lang=js"
import style0 from "./chapter_add.vue?vue&type=style&index=0&id=05077af6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports